import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { ContentType } from '@tracking';

import Layout from './Layout';
import { LandingPageProps } from './interfaces';

const LandingPage = ({ env, isWebview, ...props }: LandingPageProps): JSX.Element => {
  const queryClient = new QueryClient();
  const { Track } = useEventTracking({
    contentId: props.id,
    contentType: ContentType.LandingPage,
  });

  return (
    <AppContextProvider env={env} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Track>
          <Layout {...props} />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default LandingPage;
